export default __webpack_public_path__ + "static/media/logo09.f59ab484.svg";